import React, { useEffect } from "react";
import Marquee from "react-fast-marquee";
import aboutBg from "../../images/bg/about-bg.png";

// Animated GIFs (fallback heading ke liye)
import gif1 from "../../images/icon/original-66948a0d81d.gif";
import gif2 from "../../images/icon/0deec720000b2066289b.gif";
import gif3 from "../../images/icon/b10c3e43e836d32554bf.gif";

// About images (fallback marquee ke liye)
import img01 from "../../images/about/img01.jpg";
import img02 from "../../images/about/img02.jpg";
import img03 from "../../images/about/img03.jpg";
import { Link } from "react-router-dom";
import { Entity } from "../../data/companies";

// ============================================================
// Who We Are (left) + Leadership Message (right) + Corporate
// Snapshot table — content companies.ts → about se aata hai.
// Agar custom about na ho to purana generic layout render hota hai.
// ============================================================
const CompanyAbout: React.FC<{ entity: Entity }> = ({ entity }) => {
  useEffect(() => {
    const bgEl = document.querySelector<HTMLElement>(".xb-about-img-wrap");
    if (bgEl) bgEl.style.backgroundImage = `url(${aboutBg})`;
  }, []);

  const aboutImages = [img01, img02, img03];
  const about = entity.about;

  // ================= Custom layout =================
  if (about) {
    return (
      <section className="about pt-140 pb-40">
        <div className="container">
          {/* ===== 2 columns: Who We Are | Leadership Message ===== */}
          <div className="row mt-none-40">
            <div className="col-lg-6 mt-40">
              <div className="sec-title about-sec-title">
                <span className="sub-title">About The Company</span>
                <h2 className="title">{about.title}</h2>
                {about.paragraphs.map((para, i) => (
                  <p className="content mt-20" key={i}>
                    {para}
                  </p>
                ))}
              </div>
            </div>

            {about.leadership && (
              <div className="col-lg-6 mt-40">
                <div className="xb-leadership">
                  <span className="sub-title">Leadership Message</span>
                  <blockquote className="xb-leadership--quote">
                    “{about.leadership.quote}”
                  </blockquote>
                  <div className="xb-leadership--author">
                    — {about.leadership.name.toUpperCase()},{" "}
                    <span>{about.leadership.role.toUpperCase()}</span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ===== Corporate Snapshot ===== */}
          {about.snapshot && (
            <div className="row mt-60 justify-content-center">
              <div className="col-lg-10">
                <div className="sec-title text-center mb-30">
                  <span className="sub-title">Corporate Snapshot</span>
                </div>
                <div className="xb-snapshot">
                  {about.snapshot.map((row, i) => (
                    <div className="xb-snapshot--row" key={i}>
                      <div className="xb-snapshot--label">{row.label}</div>
                      <div className="xb-snapshot--value">{row.value}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* ===== Numbered editorial sections (04 / 05 / 06 ...) ===== */}
          {about.sections && (
            <div className="row mt-70 justify-content-center">
              <div className="col-lg-10">
                {about.sections.map((sec, i) => (
                  <div
                    className="xb-numsec wow fadeInUp"
                    data-wow-delay={`${i * 120}ms`}
                    data-wow-duration="700ms"
                    key={sec.num}
                  >
                    <div className="xb-numsec--num">{sec.num}</div>
                    <div className="xb-numsec--body">
                      <h3 className="xb-numsec--title xb-text-reveal">
                        {sec.title}
                      </h3>
                      {sec.paragraphs.map((para, j) => (
                        <p className="xb-numsec--para" key={j}>
                          {para}
                        </p>
                      ))}
                      {sec.chips && (
                        <div className="xb-numsec--chips">
                          {sec.chipsIntro && <span>{sec.chipsIntro}</span>}
                          {sec.chips.map((chip) => (
                            <em className="xb-numsec--chip" key={chip}>
                              {chip}
                            </em>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>
    );
  }

  // ================= Fallback (generic) =================
  return (
    <section className="about pt-140">
      <div className="container">
        <div className="sec-title about-sec-title mb-75">
          <span className="sub-title">Who We Are?</span>
          <h2 className="title">
            {entity.name} is
            <span>
              <img src={gif1} alt="animation" />
            </span>{" "}
            {entity.tagline.toLowerCase()}
            <span>
              <img src={gif2} alt="animation" />
            </span>
            of the KOT Enterprises ecosystem{" "}
            <span>
              <img src={gif3} alt="animation" />
            </span>
          </h2>
        </div>
      </div>

      <div className="xb-about-img-wrap bg_img wow">
        <Marquee speed={40} gradient={false} pauseOnHover={false}>
          {aboutImages.map((img, idx) => (
            <div key={idx} className="xb-about-img-item img-hove-effect">
              <div className="xb-img">
                <Link to="#">
                  <img src={img} alt={`about-${idx + 1}`} />
                </Link>
              </div>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default CompanyAbout;
